var swiper = new Swiper(".testimonialSlider", {
  effect: "slide",
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper = new Swiper(".testBoxSlider", {
  slidesPerView: 3,
  spaceBetween: 30,
  effect: "slide",
  loop: true,
  speed: 1000,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 30,
    },

    200: {
      slidesPerView: 1,
      spaceBetween: 10,
    },

    575: {
      slidesPerView: 2,
      spaceBetween: 15,
    },

    769: {
      slidesPerView: 2.3,
      spaceBetween: 20,
    },

    1025: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
